export default __webpack_public_path__ + "static/media/aboutBcg.6f7da3e0.jpeg";